import { clientApp } from './index';

export const getPaymentMethods = () => clientApp.get(`/ui/enfore/paymentmethods`);
export const getSalesCategories = () => clientApp.get(`/ui/enfore/product/salescategories`);
